import React, { FC } from 'react';

import { useSystemwidePromotionMessageQuery } from 'generated/sanity-graphql';

import { Wrapper } from './promo-message.styled';

interface PromoMessageProps {
  promoId: string;
}

const PromoMessage: FC<PromoMessageProps> = ({ promoId }) => {
  const { data } = useSystemwidePromotionMessageQuery({
    variables: {
      id: promoId,
    },
    skip: !promoId,
  });

  const promoMessage = data?.SystemwidePromotion?.promoMessage?.locale;

  if (!promoMessage) {
    return null;
  }

  return (
    <Wrapper>
      <span>{promoMessage}</span>
    </Wrapper>
  );
};

export default PromoMessage;
